<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box" v-if="config.appl">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						수료관리
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body clearfix" style="background-color: #f8f8f8;">
					<div class="box left full-width p-10" style="background-color: #f8f8f8;">
						<p class="menu-nav">
							<!--
							<span class="label" style="background-color: darkgoldenrod;">온라인</span>
							-->
							{{config.appl.lec.category}}
						</p>
						<p class="subject-tit">
							{{config.appl.lec.lecName}}
						</p>
						<table class="table2 table-hover text-center m-t-0 m-b-0">
							<tbody v-for="(curriculum,curriculumIdx) in config.appl.lec.curriculumList" :item="curriculum" :index="curriculumIdx" :key="'progress-modal-'+config.appl.applId+'-curriculum-'+curriculumIdx">
								<tr class="on">
									<td class="text-left f-14">{{curriculum.name}}</td>
									<td class="text-right f-14">
										<button class="btn-sm btn-red round" type="button" @click="printCert(curriculum)">수료증 발급</button>
									</td>
								</tr>
								<tr class="margin">
									<td colspan="2">
										<table class="full-width table-condensed m-b-5" v-for="(lesGrp,lesGrpIdx) in curriculum.lesList" :item="lesGrp" :index="lesGrpIdx" :key="'progress-modal-'+config.appl.applId+'-curriculum-'+curriculumIdx+'-lesGrp-'+lesGrp.lesId">
											<thead>
												<tr>
													<th class="text-left" colspan="2">{{lesGrpIdx+1}} 차시. {{lesGrp.title}}</th>
													<th class="text-right"></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(les,lesIdx) in lesGrp.child" :item="les" :index="lesIdx" :key="'progress-modal-'+config.appl.applId+'-curriculum-'+curriculumIdx+'-lesGrp-'+lesGrp.lesId+'-les-'+les.lesId">
													<td class="w180">{{les.title}}</td>
													<td>
														<div v-if="les.connContPath" class="progress full-width m-t-0">
															<span class="progress-bar" :style="'width:'+les.progress+'%'">{{les.progress}}%</span>
														</div>
													</td>
													<td class="w120 text-right">
														<!--
														<span v-if="les.connContPages && les.lesProgressList.length">{{les.lesProgressList.length?les.lesProgressList[les.lesProgressList.length-1].pageNum:0}} 쪽 완료 {{lesGrp.connContPages?' / 전체 '+lesGrp.connContPages+' 쪽':''}}</span>
														-->
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer p-10 clearfix" style="background-color: #f8f8f8;">
					<!--
					<button class="btn btn-darkgray m-t-30 round pull-left m-r-5" type="button">증명서 일괄 발급</button>
					<button class="btn btn-darkgray m-t-30 round pull-left" type="button">일괄 수료</button>
					<button class="btn bg-deepblue text-white m-t-30 round pull-right m-l-5" type="button">저장</button>
					<button class="btn bg-deepblue text-white m-t-30 round pull-right" type="button">수정</button>
					-->
					<button class="btn bg-deepblue text-white m-t-30 round pull-right" type="button" @click="$emit('close')">닫기</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import moment from 'moment'

export default {
	name: "ModalClassStatus",

	default: function() {
		return {
			name: this.name,
			appl: null,
			show: false,
		}
	},

	props: {
		config: Object
	},

	methods: {
		printCert: function(curriculum) {
			let mberName = this.config.appl.mber.mberName;
			let certDate = moment(this.config.appl.certDate).format("YYYY-MM-DD");
			let category = this.config.appl.lec.category;
			let lecName = curriculum.name;
			let agency = this.config.appl.mber.agency?this.config.appl.mber.agency.agencyName:"없음";
			let applEduDate = "";
			if(this.config.appl.applEduDateList.length==1) {
				applEduDate = this.config.appl.applEduDateList[0].eduStartDate+" ~ "+this.config.appl.applEduDateList[0].eduEndDate;
			} else if(this.config.appl.applEduDateList.length>1) {
				applEduDate = this.config.appl.applEduDateList[0].eduStartDate+" ~ "+this.config.appl.applEduDateList[this.config.appl.applEduDateList.length-1].eduStartDate;
			} else {
				if(this.config.appl.lec.lecEduDateList.length==1) {
					applEduDate = this.config.appl.lec.lecEduDateList[0].eduStartDate+" ~ "+this.config.appl.lec.lecEduDateList[0].eduEndDate;
				} else if(this.config.appl.lec.lecEduDateList.length>1) {
					applEduDate = this.config.appl.lec.lecEduDateList[0].eduStartDate+" ~ "+this.config.appl.lec.lecEduDateList[this.config.appl.lec.lecEduDateList.length-1].eduStartDate;
				}
			}
			window.open("/user/certificate/form.jsp?print=1&mberName="+encodeURIComponent(mberName)+"&certDate="+encodeURIComponent(certDate)+"&category="+encodeURIComponent(category)+"&lecName="+encodeURIComponent(lecName)+"&agency="+encodeURIComponent(agency)+"&applEduDate="+encodeURIComponent(applEduDate), "", "" );
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>